module.exports = __webpack_public_path__ + "524cda16b9b973d3844d3c9ca4576630.MP3";